import { LocalStorage } from 'src/common/helpers/local-storage';
import { ITransactionLookupDto } from '../../common/interfaces/dtos/ITransactionLookup';
import { store } from '../../common/redux/configure-store';
import { TransactionActions } from '../../common/redux/reducers/transaction-reducer';
import { transactionLookup } from './service/transaction-lookup';

export const getLatestTransaction = async (): Promise<void> => {
  const trainingMode = store.getState().posMode.trainingMode;
  const tillId = LocalStorage.tillId();

  const transactionLookupConfig: ITransactionLookupDto = {
    status: 'InProcess',
    trainingModeFlag: trainingMode,
    tillId,
  };
  await transactionLookup(transactionLookupConfig).then((data): void => {
    if (data && data.length) {
      const latestTime = Math.max.apply(
        null,
        data.map((t): number => new Date(t.beginDateTime ?? '').getTime()),
      );
      const latestTransaction = data.filter(
        (transaction): boolean =>
          new Date(transaction.beginDateTime ?? '').getTime() === latestTime,
      )[0];

      if (latestTransaction.transactionId) {
        store.dispatch(
          TransactionActions.setTransactionState({
            transactionId: latestTransaction.transactionId ?? '',
            sequenceNumber: latestTransaction.sequenceNumber ?? 0,
            // TODO GET TRUE VALUES FOR THESE ITEMS WHEN SAVED/RECALLED ACTIONS ARE AVAILABLE
            transactionTaxExemptApplied: false,
          }),
        );
        return;
      }
    }
    store.dispatch(TransactionActions.resetState());
  });
};
